export function setLayerFilters(layerIds = [], allFilters, map) {
    layerIds.forEach((layerId) => {
        if (map === null || map === void 0 ? void 0 : map.getLayer(layerId)) {
            try {
                map.setFilter(layerId, allFilters);
            }
            catch (e) {
                console.error("Error beim setzen der Filter", e);
            }
        }
    });
}
